import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { ProductoPresentacionesController } from './producto-presentaciones.controller';
import { ProductoPresentacionesService } from './producto-presentaciones.service';

@Module({
  imports: [PrismaModule],
  controllers: [ProductoPresentacionesController],
  providers: [ProductoPresentacionesService],
  exports: [ProductoPresentacionesService],
})
export class ProductoPresentacionesModule {}
